var render, staticRenderFns
import script from "./comp_dpc-ImagesSliderV2.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-ImagesSliderV2.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-ImagesSliderV2.vue?vue&type=style&index=0&id=31fc6002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc6002",
  null
  
)

export default component.exports